import root from "window-or-global";
import {selectAccountCountryCode, selectIpCountryCode} from "../selectors/user.selectors";
// Major member nations of the EU
// Codes are in ISO-3166 alpha-2

export const euMajorRegions: string[] = [
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'CY', // Cyprus
    'CZ', // Czech Republic
    'DE', // Germany
    'DK', // Denmark
    'EE', // Estonia
    'ES', // Spain
    'FI', // Finland
    'FR', // France
    'GB', // United Kingdom
    'GR', // Greece
    'HU', // Hungary
    'HR', // Croatia
    'IE', // Ireland, Republic of (EIRE)
    'IT', // Italy
    'LT', // Lithuania
    'LU', // Luxembourg
    'LV', // Latvia
    'MT', // Malta
    'NL', // Netherlands
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SE', // Sweden
    'SI', // Slovenia
    'SK', // Slovakia
];

// Outer Most Regions (OMR), territories in the EU that generally fall under EU jurisdiction and legislation
// Codes are in ISO-3166 alpha-2
export const euOuterMostRegions: string[] = [
    'GF', // French Guiana
    'GP', // Guadeloupe
    'MQ', // Martinique
    'ME', // Montenegro
    'YT', // Mayotte
    'RE', // Réunion
    'MF', // Saint Martin
];

// EU Major regions and OMR, in ISO-3166 alpha-2
export const euAndOuterRegions: string[] = [...euMajorRegions, ...euOuterMostRegions];

/**
 * Given an ISO-3166 alpha-2 country code, determines if it is within the Major or
 * Outer Most Regions (OMR) of the EU, which also fall generally under the same legislation.
 *
 * NOTE: Before using this for anything related to jurisdiction and application of policy, consult with legal
 *
 * @param countryCode ISO-3166 alpha-2 country code
 */
export const isEuJurisdiction = (countryCode: string): boolean => {
    return !!countryCode && euAndOuterRegions.includes(countryCode);
};

/**
 * Used on client start to setup tracking pixel behaviors
 * Due to GDPR, EU countries should not be tracked
 * @param _
 * @param envConfig
 */
export const configureTracking = ({initialState}) => {
    // trackingJs configurations, EU countries or EU account users shouldn't be tracked due to GDPR
    const accountCountry = selectAccountCountryCode(initialState);
    const ipCountry = selectIpCountryCode(initialState);
    const configurations = {
        onBeforeTrack: () => {

            // return false will not send events
            if (isEuJurisdiction(accountCountry) || isEuJurisdiction(ipCountry)) {
                return false;
            }
            return true;
        },
    };
    if (root._epicTracking) {
        root._epicTracking.configure(configurations);
    } else {
        root.addEventListener('trackingJsLoaded', () => {
            root._epicTracking.configure(configurations);
        });
    }

    return {initialState};
};
